import React, { useState, useEffect } from 'react'
import { connect, useDispatch   } from "react-redux";
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import ModalProduct from '../Products/ModalProduct';
import './Modal.scss';
import {FaAngleUp,FaAngleDown} from 'react-icons/fa'
import { setCurrentProduct } from '../../redux/Order/order.actions';
import { useTranslation } from 'react-i18next'
import Sidebar from '../Sidebar/Sidebar';
import { hotDealsAtTop_NoDealOfTheMonth, sortProductsByPriceAndName } from '../../helpers/productSorters';
import DealOfTheMonth from '../Products/DealOfTheMonth';

const mapStateToProps = (state) => ({
  products:               state.product.balls,
  sortOrder:							state.app.sortOrder,

})


const ProductChangeModal = (props) => {
    
    const { t, i18n } = useTranslation()
    const [filter, setFilter] = React.useState(0);
    const [triggerRerender, setTriggerRerender] = React.useState(0);

    const curLanguage = i18n.language.toUpperCase();

    const [filteredProds, setFilteredProds] = useState(props.products.filter(prod => prod.Live === true) );

    const {
        className,
        modal,
        events,
    } = props;

    const dispatch = useDispatch();

	  useEffect(()=>{

	    console.log("SORT ORDER IS NOW", props.sortOrder);
	    orderProducts(props.sortOrder)

	  },[props.sortOrder])

	  function filterProducts(oemArr) {
	      setFilteredProds( 
	      	hotDealsAtTop_NoDealOfTheMonth(
	      		   sortProductsByPriceAndName(props.products.filter(prod => oemArr.includes(prod.BrandID)), props.sortOrder, curLanguage)
	      	) 
	      );
	  }

    const changeSelectedProduct = (_productObj) => {
        dispatch(setCurrentProduct(_productObj));
    }

    const brandsArr = props.products.map(item => item.BrandID).filter((value, index, self) => self.indexOf(value) === index).map( id=>props.products.find(obj => obj.BrandID === id) ).map(obj => {return {BrandID: obj.BrandID,BrandName:obj.BrandName}})


    function changeOemArr(checkbox) {

        if (checkbox != 'selectall') {
          document.getElementById('selectall').checked = false;
        }

        var newArr = [];

        newArr = brandsArr.map(item => {
            var elementName = `manufacturer${item.BrandID}`;
            if (document.getElementById(elementName).checked || document.getElementById("selectall").checked) {
              return item.BrandID;
            }
        })

        filterProducts(newArr);

    }

  function orderProducts(order) {

  	let sortedProducts = hotDealsAtTop_NoDealOfTheMonth(sortProductsByPriceAndName(filteredProds, order, curLanguage));

    setFilteredProds(sortedProducts)

    setTriggerRerender(!triggerRerender)

  }


    const closeBtn = <button className="close" onClick={events.toggleproductChangeModal}>&times;</button>;

    return (
        <div>
            <Modal isOpen={modal} className={className}>
                <ModalHeader close={closeBtn}>
                    {t('SELECT A DIFFERENT BALL')}
                </ModalHeader>
                <ModalBody>
                    <div className='row'>
                        <div className='col-md-4'>
          <Sidebar filterProducts={filterProducts} orderProducts={orderProducts} />

                        </div>
                        <div className='col-md-8'>
                            <div className='row'>
                            	<DealOfTheMonth changeSelectedProduct={changeSelectedProduct} events={events} windowType={'modal'} />
                            </div>
                            <div className='row'>

                                {
                                    filteredProds.map(productObj => {
                                        return <div className="col-6"><ModalProduct changeSelectedProduct={changeSelectedProduct} key={productObj.ID} events={events} product={productObj} /></div>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
}

export default connect(mapStateToProps)(ProductChangeModal)